"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAuthContext = useAuthContext;
exports.AuthProvider = AuthProvider;
exports.AuthContext = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var AuthContext = /*#__PURE__*/_react["default"].createContext({});

exports.AuthContext = AuthContext;

function useAuthContext() {
  return (0, _react.useContext)(AuthContext);
}

function AuthProvider(props) {
  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      token = _useState2[0],
      setToken = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      currentUser = _useState4[0],
      setCurrentUser = _useState4[1];

  var isLogin = (0, _react.useMemo)(function () {
    return !!token;
  }, [token]);

  function logout() {
    setCurrentUser(undefined);
    setToken('');
    localStorage.setItem('token', '');
  }

  return /*#__PURE__*/_react["default"].createElement(AuthContext.Provider, {
    value: {
      logout: logout,
      token: token,
      setToken: setToken,
      isLogin: isLogin,
      currentUser: currentUser,
      setCurrentUser: setCurrentUser
    }
  }, props.children);
}